
import ResultProductCard from "@/components/common/ResultProductCard";
import UiSwiperCarousel from "~/components/UI/UiSwiperCarousel.vue";

export default {
  name: "RelatedProductBlock",
  components: {
    UiSwiperCarousel,
    ResultProductCard,
  },
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    mapedData() {
      return this.data.map((el) => ({ ...el, image: el?.images?.[0]?.url }));
    },
  },
};
